(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.banner-slider', {
    spaceBetween: 0,
    slidesPerView: 1,
    allowTouchMove: true,
    autoHeight: true,
    navigation: {
      nextEl: ".banner-slider .swiper-button-next",
      prevEl: ".banner-slider .swiper-button-prev",
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    on: {
      init: function(){
        if (this.slides.length <= 1) {
          this.allowSlidePrev = this.allowSlideNext = false;
          this.el.querySelector(".swiper-button-prev").style.display = 'none'
          this.el.querySelector(".swiper-button-next").style.display = 'none'
        }
        this.updateAutoHeight()
      }
    }
  });   
})
                                   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  const collectionTabs = [...document.querySelectorAll('.collection-tabs')];
        
  collectionTabs.forEach((ct)=>{ // assign events for each collection tabs section
    let tabs =  [...ct.querySelectorAll('.collection-tabs__content')];
    let buttons = [...ct.querySelectorAll('button[data-collection]')];
    
    buttons.forEach((b)=>{ // change tab visibility on click
      b.addEventListener('click', ()=>{
        buttons.forEach((b)=>b.classList.remove('is-active'));
        b.classList.add('is-active');
        
        let collection = b.getAttribute('data-collection');
        tabs.forEach(t => t.classList.remove('is-active'));

        let tab = document.querySelectorAll(`.collection-tabs__content[data-collection="${collection}"]`);
        tab.forEach(x => x.classList.add('is-active'));

        let text = b.textContent || b.innerText;  

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'tab_click',
          'description': text.trim()
        });
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabv2"] && !Shopify.designMode) return;
  try {
    
  // assign tab click events
  const collectionTabs = [...document.querySelectorAll('.collection-tabs-v2')];
        
  collectionTabs.forEach((ct)=>{ // assign events for each collection tabs section
    let tabs =  [...ct.querySelectorAll('.collection-tabs__content')];
    let buttons = [...ct.querySelectorAll('button[data-collection]')];
    
    buttons.forEach((b)=>{ // change tab visibility on click
      b.addEventListener('click', ()=>{
        buttons.forEach((b)=>b.classList.remove('is-active'));
        b.classList.add('is-active');
        
        let collection = b.getAttribute('data-collection');
        tabs.forEach(t => t.classList.remove('is-active'));

        let tab = document.querySelectorAll(`.collection-tabs__content[data-collection="${collection}"]`);
        tab.forEach(x => x.classList.add('is-active'));

        // Refresh any swiper carousels in the newly active tab
        tab.forEach(tabContent => {
          const swipers = tabContent.querySelectorAll('.swiper');
          swipers.forEach(swiperEl => {
            if (swiperEl.swiper) {

              // Force height recalculation
              swiperEl.style.height = 'auto';
              swiperEl.swiper.wrapperEl.style.height = 'auto';
              
              // Update swiper
              swiperEl.swiper.update();
              swiperEl.swiper.updateSlides();
              swiperEl.swiper.updateProgress();
              swiperEl.swiper.updateSlidesClasses();
              swiperEl.swiper.updateAutoHeight(0);
            }
          });
        });
   
        let text = b.textContent || b.innerText;  

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'tab_click',
          'description': text.trim()
        });
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"] && !Shopify.designMode) return;
  try {
    
  const productSpotlights = [...document.querySelectorAll('.product-spotlight')]
  
  productSpotlights.forEach((ps)=>{
    const buttons = [...ps.querySelectorAll('button[data-tab]')]
    
    buttons.forEach((b)=>{
      b.addEventListener('click', ()=>{
        buttons.forEach((b)=>b.classList.remove('is-active'))
        b.classList.add('is-active')
        
        const tabId = b.getAttribute('data-tab')

        const tabs = [...ps.querySelectorAll('.tab-content')]
        tabs.forEach(t => t.classList.remove('is-active'));
        
        document.querySelector(`.tab-content[data-tab="${tabId}"]`).classList.add('is-active')
      })
    })
  })



  } catch(e) { console.error(e); }
})();
})();
